import React, { useState, useEffect } from 'react';
import { useHistory, useParams } from 'react-router-dom';
import { Spin, Form, message, Button } from 'antd';
import { Config } from '../../public/js/config';

import './surveyScreenSelectLanguage.css';
import '../newMain/newMain.css';


const SurveyScreenSelectLanguage = (props) => {

    const history = useHistory();
    const [isLoad, setIsLoad] = useState(false);
    const [isShow, setIsShow] = useState(true);
    const [form] = Form.useForm();
    const { authorizationCode } = useParams();

    useEffect(() => {
        if (authorizationCode) {
            checkCode()
        } else {
            message.error("Link has failed.");
            setIsShow(false);
        }
    }, []);

    const checkCode = () => {
        if(isLoad) {
            return;
        }
        let model = {authorizationCode: authorizationCode};
        setIsLoad(true);
        fetch(Config.apiServer + "partner/surveyRecord/checkAuthorizationCode", {
            method: 'POST',
            body: JSON.stringify(model),
            headers: Config.header,
            mode: 'cors',
            cache: 'default'
        }).then(res => res.json()).then((data) => {
            if ("SUCCESS" === data.msg) {
                setIsShow(true)
            } else {
                message.error(data.msg);
                setIsShow(false);
            }
        }).catch(err => { }).finally(() => setIsLoad(false));
    }

    const jump = (path, lang) => {
        history.push(path + '/' + authorizationCode + '/' + lang);
    }

    return (
        <div id="container" className='websiteTemplate surveyScreenSelectLanguage'>
            {isShow ? <Spin size="large" spinning={isLoad} >
                <div className='websiteSysButtonRow'>
                    <div className='detailStatusBox'>
                        <div className='detailTitle'></div>
                    </div>
                </div>
                <div className='websiteSysContentBox'>
                    <Form form={form}>
                        <div className='marginBot'>
                            <div className='contentTitle'>
                                香港高等教育科技学院
                            </div>
                            <div className='contentTitle'>
                                香港高等教育科技學院
                            </div>
                            <div className='contentTitle'>
                                TECHNOLOGICAL AND HIGHER EDUCATION INSTITUTE OF HONG KONG
                            </div>
                        </div>
                        <div className='marginBot2'>
                            <div className='contentTitle'>
                                工作综合学习行业主管评估调查
                            </div>
                            <div className='contentTitle'>
                                工作綜合學習行業主管評估調查
                            </div>
                            <div className='contentTitle'>
                                Work-integrated Learning Industry Supervisor Evaluation Survey
                            </div>
                        </div>
                        <div className=''>
                            <div className='contentTitle'>
                                请选择你的语言
                            </div>
                            <div className='contentTitle'>
                                請選擇你的語言
                            </div>
                            <div className='contentTitle'>
                                Please select your language
                            </div>
                        </div>
                        <div className=''>
                            <div className='contentTitleDisplay'>
                            {/* <Button type="text">Text</Button> */}
                                <Button  className='websiteSysButton signatureButton marginZY' onClick={() => jump("/surveyScreen", "SC")}>简体中文</Button>
                                <Button  className='websiteSysButton signatureButton marginZY' onClick={() => jump("/surveyScreen", "TC")}>繁體中文</Button>
                                <Button  className='websiteSysButton signatureButton marginZY' onClick={() => jump("/surveyScreen", "EN")}>English</Button>
                            </div>
                        </div>
                    </Form>
                </div>
            </Spin>
                : <div className='contentTitle flexCenter'>Link has failed.</div>
            }
        </div>
    )

}

export default SurveyScreenSelectLanguage;